<template>
  <div class="indexMobile">
    <!-- <div style="height:0;overflow: hidden;margin:0;padding-bottom: 72%;position:relative;"> -->
    <div class="indexImgFixed">
      <!-- <img style="width:100%;display: block;position: absolute;top:0;bottom: 0;"
        src="https://cdn.youjiajk.com/indexBannerMobile.png" alt=""> -->
        <el-carousel trigger="click" height = "390px">
        <el-carousel-item v-for="(item,index) in bannerPics" :key="index">
          <img class="img" :src="item.imageUrl" @click="bannerClick(item)"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="backgroundGray1 indexItem1">
      <div class="item" @click="goPage('insurancePlan')">
        <div class="title">商业保险创新解决方案</div>
        <div class="desc">
          <span>助力保费规模增长可持续</span>
          <img src="../../assets/image/indexIcon1.png" />
        </div>
      </div>
      <div class="item" @click="goPage('insurancePlan')">
        <div class="title">医疗行业解决方案</div>
        <div class="desc">
          <span>助力用户全周期疾病管理</span>
          <img src="../../assets/image/indexIcon1.png" />
        </div>
      </div>
      <div class="item" @click="goPage('insurancePlan')">
        <div class="title">健康企业一站式解决方案</div>
        <div class="desc">
          <span>助力员工健康风险可预防</span>
          <img src="../../assets/image/indexIcon1.png" />
        </div>
      </div>
    </div>
    <div class="banner">
      <div class="swiper">
        <swiper class="swiper swiper-no-swiping" :options="swiperOptionh">
          <swiper-slide>
            <div class="swiperCon">
              <div class="txt">
                <div class="title">
                  <img src="../../assets/image/indexIcon.png" alt="">
                  <span>家医优护</span>
                </div>
                <div class="con">
                  <p>拥有
                    <countTo class="num" :startVal="startVal" :endVal="endVal4" :duration="2000" separator=""></countTo>
                    <span class="num">+</span>
                    位自有及签约医护伙伴
                  </p>
                  <p>覆盖全国
                    <countTo class="num" :startVal="startVal" :endVal="endVal5" :duration="1500" separator=""></countTo>
                    <span class="num">+</span>
                    座城市
                  </p>
                  <p>
                    <span class="num">7*24</span>
                    小时管家式守护
                  </p>
                </div>
              </div>
              <img class="swiperSliderImg" src="https://cdn.youjiajk.com/swiperBanner1.png" alt="">
            </div>
          </swiper-slide>
          <!-- <swiper-slide>
            <div class="swiperCon">
              <div class="txt">
                <div class="title">
                  <img src="../../assets/image/indexIcon.png" alt="">
                  <span>药品福利管理</span>
                </div>
                <div class="con">
                  <p>自营自建（青岛）互联网医院</p>
                  <p>自有及直签
                    <countTo class="num" :startVal="startVal" :endVal="endVal6" :duration="2000" separator=""></countTo>
                    <span class="num">+</span>
                    家合作药店
                  </p>
                  <p>已覆盖
                    <countTo class="num" :startVal="startVal" :endVal="endVal12" :duration="2000" separator=""></countTo>
                    <span class="num">万+</span>
                    商品SKU
                  </p>
                </div>
              </div>
              <img class="swiperSliderImg" src="https://cdn.youjiajk.com/swiperBanner2.png" alt="">
            </div>
          </swiper-slide> -->
          <swiper-slide>
            <div class="swiperCon">
              <div class="txt">
                <div class="title">
                  <img src="../../assets/image/indexIcon.png" alt="">
                  <span>优选医疗网络</span>
                </div>
                <div class="con">
                  <p>系统链接
                    <countTo class="num" :startVal="startVal" :endVal="endVal7" :duration="2000" separator=""></countTo>
                    <span class="num">+</span>
                    家体检机构、
                  </p>
                  <p>
                    <countTo class="num" :startVal="startVal" :endVal="endVal8" :duration="2000" separator=""></countTo>
                    <span class="num">+</span>
                    家眼科机构、
                    <countTo class="num" :startVal="startVal" :endVal="endVal9" :duration="2000" separator=""></countTo>
                    <span class="num">+</span>
                    家齿科机构
                  </p>
                  <p>近
                    <countTo class="num" :startVal="startVal" :endVal="endVal10" :duration="2000" separator="">
                    </countTo><span class="num">+</span>
                    家中医诊所
                  </p>
                </div>
              </div>
              <img class="swiperSliderImg" src="https://cdn.youjiajk.com/swiperBanner3.png" alt="">
            </div>
          </swiper-slide>
          <div class="swiper-pagination swiper-pagination-h" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <div class="work" ref="work">
      <div class="container">
        <div class="title">服务客户</div>
        <div class="imgList">
          <div>
            <div>
              <countTo class="num" :startVal="startVal" :endVal="endVal1" :duration="1500" separator=""></countTo>
              <span>+</span>
            </div>
            <p>保司及企业客户</p>
          </div>
          <div>
            <div>
              <countTo class="num" :startVal="startVal" :endVal="endVal2" :duration="2000" separator=""></countTo>
              万<span>+</span>
            </div>
            <p>付费终端用户</p>
          </div>
          <div>
            <div>
              <countTo class="num" :startVal="startVal" :endVal="endVal3" :duration="1800"></countTo>万<span>+</span>
            </div>
            <p>累计服务人数</p>
          </div>
          <div>
            <div>
              <countTo class="num" :startVal="startVal" :endVal="endVal11" :duration="1800"></countTo>万<span>+</span>
            </div>
            <p>累计服务人次</p>
          </div>
        </div>
      </div>
    </div>

    <img src="https://cdn.youjiajk.com/indexMobileBanner3.png" style="width: 100%;height:9.17rem;" alt="">
    <!-- 合作伙伴 -->
    <div class="cooperation backgroundGray">
      <div class="">
        <div class="title">
          <p>合作伙伴</p>
          <p class="subTitle"><span @click="logoIndex = 1">保司+渠道</span> | <span @click="logoIndex = 2">医疗网络</span></p>
        </div>
        <div class="content" v-if="logoIndex == 1">
          <vue-seamless-scroll :data="cooperationList" :class-option="optionLeft" class="seamless-warp2">
            <ul class="item">
              <li><img src="../../assets/image/cooperation/1@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/2@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/3@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/4@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/5@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/6@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/7@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/8@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/38@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/39@2x.png" /></li>
            </ul>
          </vue-seamless-scroll>
          <vue-seamless-scroll :data="cooperationList1" :class-option="optionLeft1" class="seamless-warp2"
            v-if="isScroll">
            <ul class="item">
              <li><img src="../../assets/image/cooperation/9@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/10@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/11@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/12@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/13@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/14@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/15@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/16@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/17@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/37@2x.png" /></li>
            </ul>
            </ul>
          </vue-seamless-scroll>
          <vue-seamless-scroll :data="cooperationList2" :class-option="optionLeft" class="seamless-warp1">
            <ul class="item">
              <li><img src="../../assets/image/cooperation/18@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/19@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/20@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/21@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/22@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/23@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/24@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/25@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/36@2x.png" /></li>
            </ul>
          </vue-seamless-scroll>
          <vue-seamless-scroll :data="cooperationList3" :class-option="optionLeft1" class="seamless-warp2"
            v-if="isScroll1">
            <ul class="item">
              <li><img src="../../assets/image/cooperation/26@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/27@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/28@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/29@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/30@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/31@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/32@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/33@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/34@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/35@2x.png" /></li>
            </ul>
          </vue-seamless-scroll>
        </div>
        <div class="content" v-if="logoIndex == 2">
          <vue-seamless-scroll :data="cooperationList4" :class-option="optionLeft3" class="seamless-warp3">
            <ul class="item">
              <li><img src="../../assets/image/cooperation/gys_1@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_2@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_3@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_4@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_5@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_6@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_7@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_8@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_9@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_10@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_11@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_12@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_26@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_28@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_30@2x.png" /></li>
            </ul>
          </vue-seamless-scroll>
          <vue-seamless-scroll :data="cooperationList5" :class-option="optionLeft3" class="seamless-warp3"
            v-if="isScroll">
            <ul class="item">
              <li><img src="../../assets/image/cooperation/gys_13@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_14@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_15@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_16@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_17@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_18@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_19@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_20@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_21@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_22@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_23@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_24@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_25@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_27@2x.png" /></li>
              <li><img src="../../assets/image/cooperation/gys_29@2x.png" /></li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import {
  swiper,
  swiperSlide
} from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import countTo from 'vue-count-to'
import vueSeamlessScroll from 'vue-seamless-scroll'
let vm = null
export default {
  props:['configurationData','bannerPics'],
  components: {
    swiper,
    swiperSlide,
    countTo,
    vueSeamlessScroll
  },
  data () {
    return {
      swiperCurrentIndex: 0,
      itemList: [{
        title: '保险端解决方案',
        iconUrl: 'https://cdn.youjiajk.com/%E4%BF%9D%E9%99%A9%E7%AB%AF.png',
        desc: '基于数据智能技术与优选医疗网络<br />为商业保险提供数字化医健保创新方案',
        path: 'insurancePlan'
      },
      {
        title: '互联网平台合作',
        iconUrl: 'https://cdn.youjiajk.com/%E4%BA%92%E8%81%94%E7%BD%91.png',
        desc: '让医疗健康赋能，温暖互联网平台',
        path: 'internet'
      },
      {
        title: '医疗供给端',
        iconUrl: 'https://cdn.youjiajk.com/%E5%8C%BB%E7%96%97%E4%BE%9B%E7%BB%99%E7%AB%AF.png',
        desc: '医疗供需“精准”匹配，给用户“需要”的服务',
        path: 'medical'
      }
      ],
      swiperOptionh: {
        spaceBetween: 0,
        pagination: {
          el: '.swiper-pagination-h',
          clickable: true,
          renderBullet: function (index, className) {
            let imgUrl;
            let txt;
            if (index == 0) {
              imgUrl = "https://cdn.youjiajk.com/swiperIcon1.png"
              txt = '家医优护'
            } 
            // else if (index == 1) {
            //   imgUrl = 'https://cdn.youjiajk.com/swiperIcon2.png'
            //   txt = '药品福利管理'
            // } 
            else if (index == 1) {
              imgUrl = 'https://cdn.youjiajk.com/swiperIcon3.png'
              txt = '优选医疗网络'
            }
            return '<p class="' + className + '">' + '<img src=" ' + imgUrl + '" />' + '<span>' + txt +
              '</span></p>'
          }
        },
        loop: false,
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },
        autoplay: false,
        on: {
          slideChange () {
            vm.swiperCurrentIndex = this.activeIndex
          }
        }
      },
      startVal: 0,
      endVal1: 0,
      endVal2: 0,
      endVal3: 0,
      endVal4: 0,
      endVal5: 0,
      endVal6: 0,
      endVal7: 0,
      endVal8: 0,
      endVal9: 0,
      endVal10: 0,
      endVal11: 0,
      endVal12: 0,
      cooperationList: [{
        imgUrl: 'https://cdn.youjiajk.com/cooperation1_index.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation2_index.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation3_index.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation4_index.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation5_index.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation6_index.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation7_index.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation8_index.png'
      },
      ],
      cooperationList1: [
        {
          imgUrl: 'https://cdn.youjiajk.com/cooperation9_index.png'
        },
        {
          imgUrl: 'https://cdn.youjiajk.com/cooperation12_index.png'
        },
        {
          imgUrl: 'https://cdn.youjiajk.com/cooperation15_index.png'
        },
        {
          imgUrl: 'https://cdn.youjiajk.com/cooperation18.png'
        },
        {
          imgUrl: 'https://cdn.youjiajk.com/cooperation21.png'
        },
        {
          imgUrl: 'https://cdn.youjiajk.com/cooperation24.png'
        },
        {
          imgUrl: 'https://cdn.youjiajk.com/cooperation27.png'
        }, {
          imgUrl: 'https://cdn.youjiajk.com/cooperation32.png'
        },
        {
          imgUrl: 'https://cdn.youjiajk.com/cooperation33.png'
        }
      ],
      cooperationList2: [{
        imgUrl: 'https://cdn.youjiajk.com/cooperation34.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation35.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation36.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation37.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation38.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation39.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation42.png'
      },
      {
        imgUrl: 'https://cdn.youjiajk.com/cooperation45.png'
      },
      ],
      cooperationList3: [
        {
          imgUrl: 'https://cdn.youjiajk.com/cooperation48.png'
        },
        {
          imgUrl: 'https://cdn.youjiajk.com/cooperation51.png'
        },
        {
          imgUrl: 'https://cdn.youjiajk.com/cooperation52.png'
        },
        {
          imgUrl: 'https://cdn.youjiajk.com/cooperation53.png'
        },
        {
          imgUrl: 'https://cdn.youjiajk.com/cooperation54.png'
        },
        {
          imgUrl: 'https://cdn.youjiajk.com/cooperation55.png'
        },
        {
          imgUrl: 'https://cdn.youjiajk.com/cooperation56.png'
        },
        {
          imgUrl: 'https://cdn.youjiajk.com/cooperation57.png'
        },
        {
          imgUrl: 'https://cdn.youjiajk.com/cooperation58.png'
        }],
      cooperationList4: [{
        imgUrl: 'https://cdn.youjiajk.com/cooperation10_index.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation11_index.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation13_index.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation14_index.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation16.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation17.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation19.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation20.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation22.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation23.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation25.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation26.png'
      }],
      cooperationList5: [{
        imgUrl: 'https://cdn.youjiajk.com/cooperation28.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation29.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation30.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation31.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation40.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation41.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation43.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation44.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation46.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation47.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation49.png'
      }, {
        imgUrl: 'https://cdn.youjiajk.com/cooperation50.png'
      },],
      isScroll: false,
      isScroll1: false,
      logoIndex: 1
    }
  },
  created () {
    vm = this
    setTimeout(() => {
      this.endVal4 = Number(this.configurationData[0].dvalue)
      this.endVal5 = Number(this.configurationData[1].dvalue)
      this.endVal6 = 40000
      this.endVal7 = Number(this.configurationData[2].dvalue)
      this.endVal8 = Number(this.configurationData[3].dvalue)
      this.endVal9 = Number(this.configurationData[4].dvalue)
      this.endVal10 = Number(this.configurationData[5].dvalue)
    }, 800)
    setTimeout(() => {
      this.isScroll = true
    }, 1500)
    setTimeout(() => {
      this.isScroll1 = true
    }, 2000)
  },
  computed: {
    optionLeft () {
      return {
        direction: 2,
        limitMoveNum: 8,
        step: 0.4,
      }
    },
    optionLeft1 () {
      return {
        direction: 2,
        limitMoveNum: 9,
        step: 0.4,
      }
    },
    optionLeft3 () {
      return {
        direction: 2,
        limitMoveNum: 12,
        step: 0.4
      }
    }
  },
  watch: {
    swiperCurrentIndex (val) {
      console.log(val)
      if (val == 0) {
        this.endVal4 = 0
        this.endVal5 = 0
        setTimeout(() => {
          this.endVal4 = Number(this.configurationData[0].dvalue)
          this.endVal5 = Number(this.configurationData[1].dvalue)
        }, 0)
      }
      if (val == 1) {
        this.endVal6 = 0
        this.endVal12 = 0
        setTimeout(() => {
          this.endVal6 = 40000
          this.endVal12 = 20
        }, 0)
      }
      if (val == 2) {
        this.endVal7 = 0
        this.endVal8 = 0
        this.endVal9 = 0
        this.endVal10 = 0
        setTimeout(() => {
          this.endVal7 = 4000
          this.endVal8 = 1500
          this.endVal9 = 2600
          this.endVal10 = 500
        }, 0)
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.scrolling)
  },
  methods: {
    goPage (name) {
      this.$router.push({
        name: name
      })
    },
    bannerClick(item) {
      if (item.jumpType == 1 && item.jumpUrl.length > 0) {
        window.location.href = item.jumpUrl;
      }
    },
    scrolling () {
      let top1 = document.body.scrollTop || document.documentElement.scrollTop //获取滚动条位置 
      let top2 = this.$refs.work.getBoundingClientRect().top
      if (top2 <= 550) {
        this.endVal1 = Number(this.configurationData[6].dvalue)
        this.endVal2 = parseInt(this.configurationData[7].dvalue)
        this.endVal3 = parseInt(this.configurationData[8].dvalue)
        this.endVal11 = parseInt(this.configurationData[9].dvalue)
      }

    }
  }

}
</script>
<style lang="less">
.swiper-pagination-bullet {
  width: 0.16rem;
  height: 0.08rem;
  display: inline-block;
  border-radius: 0.15rem;
  background: #FFFFFF;
  opacity: 0.5;
}

.swiper-pagination-bullet-active {
  opacity: 1;
  background: #FFFFFF;
  width: 0.48rem;
  height: 0.08rem;
}
</style>

<style lang="less" scoped>
.backgroundGray {
  background: #F8F9FD;
}

.backgroundGray1 {
  background: #FBFCFE;
}

.indexMobile {
  display: flex;
  flex-direction: column;
  margin-top: 1.55rem;

  .bannerTop {
    img {
      width: 100%;
      height: 5.4rem;
    }
  }
}

.indexImgFixed {
  width: 100%;
  .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.indexItem1 {
  padding: 0.8rem 0.3rem;

  .item {
    background: linear-gradient(241deg, #ebf5f8 10%, #f3f1fa 26%, #f8f9fb 57%, #ffffff 89%);
    border: 0.03rem solid #ffffff;
    border-radius: 0.14rem;
    box-shadow: 0 0.36rem 0.29rem 0 rgba(0, 0, 0, 0.03);
    margin-bottom: 0.4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: Source Han Sans CN, Source Han Sans CN-6;
    color: #333333;
    padding: 0.74rem 0;

    &:last-child {
      margin-bottom: 0;
    }

    .title {
      font-size: 0.34rem;
      font-weight: 500;
      line-height: 0.51rem;
      margin-bottom: 0.26rem;
      color: #333333;
    }

    .desc {
      font-size: 0.26rem;
      font-weight: 400;
      line-height: 0.39rem;
      display: flex;
      align-items: center;

      img {
        width: 0.29rem;
        height: 0.29rem;
        margin-left: 0.1rem;
      }
    }
  }
}



.banner {
  width: 100%;
  height: 9.98rem;
  background-image: url("../../assets/image/indexBannerMobile2.png");
  background-size: 100% 100%;

  .swiper {
    width: 100%;
    position: relative;

    /deep/.swiper-container {
      width: 100%;

      .swiper-slide {
        width: 100%;
        height: 100%;
        // padding-bottom: 28.1%;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
      }

      .swiper-pagination-bullets {
        top: 0;
        display: flex;
        justify-content: center;
        margin-top: 1.4rem;
        border-bottom: 1px solid #e9ebed;
        height: 0.93rem;
      }

      .swiper-pagination {
        .swiper-pagination-bullet {
          width: 1.04rem !important;
          height: 1.04rem !important;
          display: inline-block;
          background: none;
          opacity: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 0.18rem;
          align-items: center;
          margin: 0 0.4rem;

          &:nth-child(2) {
            // margin: 0 1.22rem;
            width: 1.58rem !important;
          }

          &:nth-child(3) {
            width: 1.58rem !important;
          }

        }

        img {
          width: 0.45rem;
          height: 0.4rem;
          margin-bottom: 0.135rem;
        }

        .swiper-pagination-bullet-active {
          background-color: none;
          width: 0.72rem;
          opacity: 1;
          position: relative;

          &::after {
            content: '';
            position: absolute;
            width: 0.56rem;
            border-bottom: 0.05rem solid #FD8246;
            bottom: 0.08rem;
          }
        }
      }

      .swiperCon {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-top: 2.25rem;
        flex-direction: column;
        align-items: center;

        .txt {
          font-family: Source Han Sans CN, Source Han Sans CN-6;
          margin-top: 0.4rem;

          .title {
            font-size: 0.42rem;
            font-weight: 500;
            text-align: left;
            color: #333333;
            line-height: 0.63rem;
            margin-bottom: 0.22rem;
            display: flex;
            align-items: flex-start;

            img {
              width: 0.20rem;
              height: 0.15rem;
              margin: 0.15rem 0.14rem 0 0;
              display: inline-block;
            }
          }

          .con {
            p {
              font-size: 0.22rem;
              font-weight: 400;
              text-align: left;
              color: #000000;
              line-height: 0.56rem;
              margin-bottom: 0.19rem;

              .num {
                font-size: 0.5rem;
                font-weight: 700;
                color: #FC8046;
                font-family: DIN Alternate, DIN Alternate-9;
              }
            }
          }
        }



        .swiperSliderImg {
          width: 5.8rem;
          height: 3.52rem;
          margin-top: 0.4rem;
        }

      }
    }
  }
}

.work {
  background: url('../../assets/image/indexBannerMobile3.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 4.4rem;

  .container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 0.2rem;
    color: #000000;
    padding: 0.8rem 0;

    .title {
      font-size: 0.4rem;
      font-weight: 500;
      margin-bottom: 0.3rem;
      color: #333333;
    }

    .imgList {
      display: flex;
      // justify-content: center;
      align-items: center;
      width: 100%;
      // margin-left: 0.6rem;
      flex-wrap: wrap;

      >div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 50%;
        color: #FC8046;
        font-size: 0.4rem;
        margin-bottom: 0.2rem;


        .num {
          font-weight: 700;
          margin-bottom: 14px;
          font-family: DIN Alternate, DIN Alternate-9;
        }

        span {
          font-size: 0.4rem;
          font-weight: normal;
        }

        p {
          font-size: 0.2rem;
          color: #000000;
          margin-top: 0.11rem;
        }
      }
    }
  }
}

.mt6 {
  margin-top: 0.6rem;
}

.cooperation {
  padding: 0.8rem 0;
  background: rgba(248, 249, 253, 0.5);

  .title {
    font-size: 0.4rem;
    font-weight: 500;
    color: #333333;
    line-height: 0.6rem;
    margin-bottom: 0.2rem;
    text-align: center;

    .subTitle {
      font-size: 0.24rem;
      color: #666666;
      line-height: 0.36rem;
      font-weight: 400;
    }
  }


  .item {
    font-size: 14px;
  }

  .seamless-warp1 {
    overflow: hidden;
    height: 1.3rem;
    width: 7.5rem;

    ul.item {
      width: 19rem;

      li {
        float: left;
        list-style-type: none;
        margin-right: 0.2rem;
        margin-bottom: 1rem;

        img {
          width: 1.84rem;
          height: 0.72rem;
          box-shadow: 0 0.04rem 0.12rem rgb(0 0 0 / 4%), 0 0.08rem 0.28rem rgb(0 0 0 / 6%), 0 0.12rem 0.48rem rgb(0 0 0 / 4%);
        }
      }
    }
  }

  .seamless-warp2 {
    overflow: hidden;
    height: 1.3rem;
    width: 7.5rem;

    ul.item {
      width: 20.6rem;

      li {
        float: left;
        list-style-type: none;
        margin-right: 0.2rem;
        margin-bottom: 1rem;

        img {
          width: 1.84rem;
          height: 0.72rem;
          box-shadow: 0 0.04rem 0.12rem rgb(0 0 0 / 4%), 0 0.08rem 0.28rem rgb(0 0 0 / 6%), 0 0.12rem 0.48rem rgb(0 0 0 / 4%);
        }
      }
    }
  }

  .seamless-warp3 {
    overflow: hidden;
    height: 1.3rem;
    width: 7.5rem;

    ul.item {
      width: 29rem;

      li {
        float: left;
        list-style-type: none;
        margin-right: 0.2rem;
        margin-bottom: 1rem;

        img {
          width: 1.84rem;
          height: 0.72rem;
          box-shadow: 0 0.04rem 0.12rem rgb(0 0 0 / 4%), 0 0.08rem 0.28rem rgb(0 0 0 / 6%), 0 0.12rem 0.48rem rgb(0 0 0 / 4%);
        }
      }
    }
  }

  /deep/ .swiper-wrapper {
    transition-timing-function: linear !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/indexMobile.vue